import Container from '@admin/components/container'
import Search from '@admin/components/search'
import Loader from '@admin/components/loader'
import Chart from '@admin/components/chart'
import Icon from '@admin/components/icon'
import SocialCampaignToken from './token'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'
import qs from 'qs'

class Card extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    network: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    daterange: PropTypes.object,
    isExpanded: PropTypes.bool,
    program: PropTypes.object,
    showChart: PropTypes.bool,
    showTable: PropTypes.bool
  }

  state = {
    social_campaign_id: null,
    data: null
  }

  _handleChoose = this._handleChoose.bind(this)

  render() {
    const { showChart, showTable } = this.props
    const { data } = this.state
    const keys = this._getKeys()
    if(!data) return <Loader />
    const metric = this._getMetric(data)
    return (
      <div className="maha-dashboard-card-body">
        { showTable && 
          <div className="maha-dashboard-card-sidebar">
            <Search { ...this._getSearch() } />
          </div>
        }
        <div className="maha-dashboard-card-detail">
          <div className="maha-dashboard-card-detail-header">
            <div className="maha-dashboard-card-detail-title">
              <T text={ this._getLabel(keys.title) } />
            </div>
            <div className="maha-dashboard-card-detail-subtitle">
              { data.summary.label }
            </div>
            <div className="maha-dashboard-card-detail-metric">
              <div className="maha-dashboard-card-detail-metric-inner">
                <div className="maha-dashboard-card-detail-metric-text">
                  { metric.value }
                </div>
                { metric.delta &&
                  <div className={`maha-dashboard-card-detail-metric-delta ${ metric.delta.direction }`}>
                    <Icon icon={`caret-${ metric.delta.direction }`} /> { metric.delta.percent }
                  </div>
                }
              </div>
            </div>
          </div>
          { showChart &&
            <div className="maha-dashboard-card-detail-chart">
              <Chart { ...this._getChart(keys, data) } />
            </div>
          }
          { showTable &&
            <div className="maha-dashboard-card-detail-table">
              <table>
                <thead>
                  <tr>
                    <th><T text="t(Date)" /></th>
                    <th>Instagram</th>
                    <th>Facebook</th>
                    <th>Combined</th>
                  </tr>
                </thead>
                <tbody>
                  { data.details.map((record, index) => (
                    <tr key={`record_${index}`} onClick={ this._handleClick.bind(this, keys.metric, record) }>
                      <td>{ record.label }</td>
                      <td>
                        <div className="maha-dashboard-card-detail-amount">{ record.instagram }</div>
                      </td>
                      <td>
                        <div className="maha-dashboard-card-detail-amount">{ record.facebook }</div>
                      </td>
                      <td>
                        <div className="maha-dashboard-card-detail-amount">{ record.value }</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    )
  }

  componentDidMount() {
    this._handleFetch()
  }

  componentDidUpdate(prevProps, prevState) {
    const { social_campaign_id } = this.state
    if(social_campaign_id !== prevState.social_campaign_id) {
      this._handleFetch()
    }
  }

  _getChart(keys, data) {
    const { config, isExpanded } = this.props
    return {
      type: config.type,
      datasets: [
        {
          color: '#1877F2',
          label: 'Facebook',
          points: data.details.map(record => ({
            x: record.label,
            y: record.facebook
          }))
        },
        {
          color: '#E4405F',
          label: 'Instagram',
          points: data.details.map(record => ({
            x: record.label,
            y: record.instagram
          }))
        }
      ],
      options: {
        aspectRatio: isExpanded ? 2 : 1.5,
        points: config.points,
        tension: config.tension,
        grid: isExpanded,
        stacked: true
      }
    }
  }

  _getKeys() {
    const { metric } = this.props.config
    return {
      metric,
      ...metric === 'comments' ? {
        title: 't(Comments)'
      } : metric === 'clicks' ? {
        title: 't(Clicks)'
      } : metric === 'engagement' ? {
        title: 't(Engagement)'
      } : metric === 'impressions' ? {
        title: 't(Impressions)'
      } : metric === 'reach' ? {
        title: 't(Reach)'
      } : metric === 'shares' ? {
        title: 't(Shares)'
      } : metric === 'saves' ? {
        title: 't(Saves)'
      } : metric === 'video_views' ? {
        title: 't(Video Views)'
      } : metric === 'reactions' ? {
        title: 't(Reactions)'
      } : {}
    }
  }

  _getLabel(label) {
    const { config, program } = this.props
    const { team } = this.context.admin
    if(config.title) return config.title
    if(config.scope === 'program' && team.has_programs) return `${label} - ${program.title}`
    return label
  }

  _getMetric(data) {
    const { current_value, previous_value, delta } = data.summary
    const percent = delta === 0 ? null : previous_value === 0 ? 1 : Math.abs((delta) / previous_value)
    return {
      value: current_value < 1000 ? current_value : numeral(current_value).format('0.00a').toUpperCase(),
      delta: percent > 0 ? {
        direction: delta < 0 ? 'down' : 'up',
        percent: percent && percent !== 0 ? numeral(percent).format('0.00%') : null
      } : null
    }
  }

  _getSearch() {
    const { config, daterange } = this.props
    return {
      endpoint: '/api/admin/dashboards/campaigns/social_campaign_metric/campaigns',
      valueKey: 'id',
      textKey: 'title',
      deselectable: true,
      defaultQuery: {
        metric: config.metric,
        program_id: config.program_id,
        daterange 
      },
      entity: 't(social campaign)',
      format: (social_campaign) => (
        <SocialCampaignToken social_campaign={ social_campaign }/>
      ),
      onChange: this._handleChoose
    }
  }

  _handleChoose(social_campaign_id) {
    this.setState({ 
      social_campaign_id: social_campaign_id || null
    })
  }

  _handleClick(metric, record) {
    const { program } = this.props
    const { social_campaign_id } = this.state
    const filter = qs.stringify({
      metric,
      ...program ? { program_id: program.id } : {},
      social_campaign_id,
      start_date: moment.utc(record.start).format('YYYY-MM-DD'),
      end_date: moment.utc(record.end).format('YYYY-MM-DD')
    }, { encode: false })
    this.context.router.push(`/admin/dashboards/campaigns/social_campaign_metric?${filter}`)
  }

  _handleFetch() {
    const { config, daterange } = this.props
    const { social_campaign_id } = this.state
    this.context.network.request({
      endpoint: '/api/admin/dashboards/campaigns/social_campaign_metric/card',
      method: 'GET',
      filter: {
        metric: config.metric,
        social_campaign_id,
        program_id: config.program_id,
        daterange 
      },
      onSuccess: ({ data }) => {
        this.setState({ data })
      }
    })
  }

}

const mapResources = (props, context) => ({
  ...props.config.program_id ? {
    program: `/api/admin/team/programs/${props.config.program_id}`
  } : {}
})

export default Container(mapResources)(Card)
